import { useState, useEffect } from 'react'
import { WorkspaceSettings } from 'types'
import Styles from './ScimSettings.module.scss'
import SharedStyles from '../SecuritySettings.module.scss'
import { ScimTokenInput } from './TokenInput/ScimTokenInput'
import { Heading } from 'blaze-ui/Heading/Heading'
import { Text } from 'blaze-ui/Text/Text'

interface Props {
  workspace?: WorkspaceSettings
}

export const ScimSettings = ({ workspace }: Props) => {
  const [isSaving, setIsSaving] = useState(false)
  const [enableScim, setEnableScim] = useState(false)

  useEffect(() => {
    if (workspace) {
      setEnableScim(workspace.scim_enabled)
    }
  }, [workspace])

  return (
    <>
      <div className={SharedStyles.settingsOption}>
        <div className={SharedStyles.toggleRow}>
          <Heading level={5}>SCIM provisioning & deprovisioning</Heading>
        </div>
        {!enableScim && (
          <div className={Styles.reachOutText}>
            <Text variant="secondary" color="var(--dark-60)">
              Reach out to <a href="mailto:support@blaze.ai">support@blaze.ai</a> if you need to set up SCIM for your
              organization.
            </Text>
          </div>
        )}
        <div className={SharedStyles.helpText}>
          <Text variant="secondary" color="var(--dark-60)">
            SCIM allows you to centralize the provisioning and deprovisioning of users in Blaze. Once enabled, you must
            configure your IdP to use the below token in order for it to activate and deactivate users.
          </Text>
        </div>
        <div className={Styles.scimSettings}>
          {enableScim && (
            <ScimTokenInput
              isDisabled={!enableScim}
              workspace={workspace}
              setIsSaving={setIsSaving}
              isSaving={isSaving}
            />
          )}
        </div>
      </div>
    </>
  )
}
